import React from 'react'
import useMount from 'react-use/lib/useMount'
import { Field } from 'redux-form'
import Radio from 'components/Input/Radio'

import { PrevNextButtons } from '../PrevNextButtons'
import { AvailablePremiumNumbers } from '../AvailablePremiumNumbers'
import { AvailableStandardNumbers } from '../AvailableStandardNumbers'

import cn from 'classnames'
import sText from 'components/Text/Text.scss'
import sMarg from 'styles/modules/margins.scss'

export const SelectStandardOrPremiumNumberStepComponent = props => {
  const { onBack, clearNumber, formData, setHeadings, change } = props

  useMount(() => {
    setHeadings &&
      setHeadings({
        heading: "You've made a great choice, now let's get you a new Virtual Mobile App",
        subHeading: "Now to go Premium or Standard, that is the question, what'll it be, boss?",
      })
  })

  return (
    <div>
      <div className={cn(sText.descrip3, sMarg.mb30)}>
        Nothing beats a fresh start. We can provide both Standard and Premium Virtual Numbers.
        Premium Numbers are numbers like 0405 888 888.
      </div>

      <Field
        label="I just want a standard number"
        component={Radio}
        name="isPremiumNumber"
        radioValue={false}
        afterChange={clearNumber}
        style={{ marginBottom: '15px' }}
      />

      <Field
        label="I want a premium number"
        component={Radio}
        name="isPremiumNumber"
        radioValue={true}
        afterChange={clearNumber}
        style={{ marginBottom: '15px' }}
      />

      {formData.isPremiumNumber ? (
        <div>
          <div>Select premium number for you virtual mobile service (minimum term 24 months).</div>
          <br />
          <Field
            name="number"
            component={AvailablePremiumNumbers}
            clearNumber={clearNumber}
            change={change}
          />
        </div>
      ) : (
        <div>
          <div>Select standard number for your virtual mobile service</div>
          <br />
          <Field name="number" component={AvailableStandardNumbers} clearNumber={clearNumber} />
        </div>
      )}

      <PrevNextButtons onBack={onBack} disabled={!formData.number} />
    </div>
  )
}



// WEBPACK FOOTER //
// src/features/MobileServices/MobileServiceForm/SelectStandardOrPremiumNumberStep/SelectStandardOrPremiumNumberStep.tsx